import { Bell, Moon, Settings, Sun } from 'lucide-react';

import { useNotifications } from '../../features/notifications/notifications.api';
import { useTheme } from '../../hooks/useTheme';
import { useI18n } from '../../i18n/useI18n';

export function Header({
  notificationsActive,
  onNotifications,
  onSettings,
}: {
  readonly notificationsActive: boolean;
  readonly onNotifications: () => void;
  readonly onSettings: () => void;
}) {
  const { theme, toggleTheme } = useTheme();
  const { t } = useI18n();
  const notifications = useNotifications();
  const unread = notifications.data?.filter((notification) => !notification.read).length ?? 0;

  return (
    <header className="app-header">
      <a className="brand" href="#inicio" aria-label="FinanceGo, inicio">
        Finance<span>Go</span>
      </a>
      <div className="header-actions">
        <button
          aria-label={t('navigation.settings')}
          className="icon-button"
          type="button"
          onClick={onSettings}
        >
          <Settings aria-hidden="true" />
        </button>
        <button
          className="icon-button header-theme-toggle"
          type="button"
          aria-label={t(theme === 'dark' ? 'navigation.changeLight' : 'navigation.changeDark')}
          onClick={toggleTheme}
        >
          {theme === 'dark' ? <Sun aria-hidden="true" /> : <Moon aria-hidden="true" />}
        </button>
        <button
          aria-label={
            unread > 0
              ? t('navigation.notificationsUnread', { count: unread })
              : t('navigation.notifications')
          }
          className={notificationsActive ? 'icon-button is-active' : 'icon-button'}
          type="button"
          onClick={onNotifications}
        >
          <Bell aria-hidden="true" />
          {unread > 0 && <span className="notification-badge">{unread > 99 ? '99+' : unread}</span>}
        </button>
      </div>
    </header>
  );
}
